/**
* Created by ferto
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 10/04/2018.
*
* evaluation-answer-true-false Component
*/
<template>
  <div class="evaluation-answer-true-false">
    <el-switch
      @change="onChange"
      v-model="internalValue"
      active-text="Sí"
      inactive-text="No"
      :disabled="disabled"
    />
    <div class="only-print">
      <span class="answer-label">{{ internalValue ? 'Si' : 'No' }}</span>
    </div>
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
export default {
  name: 'EvaluationAnswerTrueFalse',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      required: true
    },
    branchType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      internalValue: false
    }
  },
  mounted () {
    if (this.question.$result) {
      for (let answer of this.question.$answers) {
        if (answer.$id === this.question.$result) {
          this.internalValue = answer.name === 'Verdadero'
        }
      }
    }
    this.calculateBaseScore()
    this.onChange()
  },
  methods: {
    calculateBaseScore () {
      this.question.$baseScore = 0
      for (let answer of this.question.$answers) {
        if (answer.$pointsPerBranch) {
          for (let branchPoints of answer.$branchPoints) {
            if (branchPoints.type === this.branchType) {
              if (this.question.$baseScore < branchPoints.points) {
                this.question.$baseScore = branchPoints.points
              }
            }
          }
        } else {
          if (this.question.$baseScore < answer.$points) {
            this.question.$baseScore = answer.$points
          }
        }
      }
    },
    onChange () {
      let type = this.internalValue ? 'Verdadero' : 'Falso'
      for (let answer of this.question.$answers) {
        if (answer.name === type) {
          this.question.$result = answer.$id
          this.question.innerEvidenceRequired = answer.$evidenceRequired
          if (answer.$pointsPerBranch) {
            for (let branchPoints of answer.$branchPoints) {
              if (branchPoints.type === this.branchType) {
                this.question.$points = branchPoints.points
                break
              }
            }
          } else {
            this.question.$points = answer.$points
          }
        }
      }
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
.evaluation-answer-true-false {
  .only-print {
    display: none;
  }
}

@media print {
  .only-print {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/answers/evaluation-answer-true-false.vue